module.exports = {
  isLocal: () => window.location.hostname === 'localhost',
  isDevelopment: () => process.env.REACT_APP_ENV === 'test',
  isProduction: () => process.env.REACT_APP_ENV === 'prod',
};
